/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_ChangeInputs */

const en_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`change`)
};

const fr_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`changement`)
};

const de_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ändern`)
};

const it_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modifica`)
};

const ru_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`изменять`)
};

const es_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cambiar`)
};

const zh_cn2_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`改变`)
};

const ja_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変化`)
};

const hi_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन`)
};

const pt_pt2_usage_change = /** @type {(inputs: Usage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mudar`)
};

/**
* | output |
* | --- |
* | "change" |
*
* @param {Usage_ChangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_change = /** @type {((inputs?: Usage_ChangeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_ChangeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_change(inputs)
	if (locale === "de") return de_usage_change(inputs)
	if (locale === "it") return it_usage_change(inputs)
	if (locale === "ru") return ru_usage_change(inputs)
	if (locale === "es") return es_usage_change(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_change(inputs)
	if (locale === "ja") return ja_usage_change(inputs)
	if (locale === "hi") return hi_usage_change(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_change(inputs)
	return en_usage_change(inputs)
});